(function () {
  var root = document.documentElement;
  var sheet = null;
  var grid = null;

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function currentView() {
    var stored = root.dataset.holeView;
    if (stored === '1' || stored === '4') return stored;
    return '2';
  }

  function syncViews() {
    var view = currentView();
    document.querySelectorAll('[data-hole-views] [data-hole-cols]').forEach(function (button) {
      var on = button.getAttribute('data-hole-cols') === view;
      button.classList.toggle('is-active', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function bindStage(card, stage, track) {
    if (stage.dataset.holeSwipe) return;
    stage.dataset.holeSwipe = 'true';
    var pointerId = null;
    var axis = '';
    var startX = 0;
    var startY = 0;
    var startIndex = 0;

    stage.addEventListener('pointerdown', function (event) {
      if (event.button !== 0) return;
      pointerId = event.pointerId;
      axis = '';
      startX = event.clientX;
      startY = event.clientY;
      startIndex = Number(card.dataset.holeIndex || 0);
    });

    stage.addEventListener('pointermove', function (event) {
      if (pointerId !== event.pointerId) return;
      var dx = event.clientX - startX;
      var dy = event.clientY - startY;
      if (!axis) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (axis === 'y') {
          pointerId = null;
          return;
        }
        track.classList.add('is-dragging');
        try { stage.setPointerCapture(event.pointerId); } catch (error) {}
      }
      if (axis !== 'x') return;
      track.style.transform = 'translateX(calc(' + (-startIndex * 100) + '% + ' + dx + 'px))';
    });

    function endDrag(event) {
      if (pointerId !== event.pointerId) return;
      var dx = event.clientX - startX;
      if (axis === 'x') {
        track.classList.remove('is-dragging');
        var width = stage.clientWidth || 1;
        var next = startIndex;
        if (dx <= -width * 0.18) next += 1;
        else if (dx >= width * 0.18) next -= 1;
        card.dataset.holeIndex = String(next);
        renderCard(card);
        if (Math.abs(dx) > 8) {
          var link = card.querySelector('a.product-card__link');
          if (link) link.dataset.holeDrag = '1';
        }
      }
      pointerId = null;
      axis = '';
    }

    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);
  }

  function hydrateSlides(track, index) {
    if (!track) return;
    var slides = track.children;
    for (var i = 0; i < slides.length; i++) {
      if (Math.abs(i - index) > 1) continue;
      var img = slides[i];
      var url = img.getAttribute('data-src');
      if (url && !img.getAttribute('src')) img.src = url;
    }
  }

  function paintStage(card, urls, index) {
    var media = card.querySelector('.product-card__media');
    if (!media) return;
    var stage = media.querySelector('.hole-card__stage');
    if (!stage) {
      stage = document.createElement('div');
      stage.className = 'hole-card__stage';
      var created = document.createElement('div');
      created.className = 'hole-card__track';
      stage.appendChild(created);
      media.appendChild(stage);
      bindStage(card, stage, created);
    }
    var track = stage.querySelector('.hole-card__track');
    var key = urls.join('|');
    if (track.dataset.holeKey !== key) {
      track.dataset.holeKey = key;
      track.classList.add('is-dragging');
      track.replaceChildren();
      urls.forEach(function (url, i) {
        var img = document.createElement('img');
        img.className = 'hole-card__slide';
        img.alt = '';
        img.draggable = false;
        img.decoding = 'async';
        img.setAttribute('data-src', url);
        if (Math.abs(i - index) <= 1) {
          img.loading = i === index ? 'eager' : 'lazy';
          img.src = url;
        } else {
          img.loading = 'lazy';
        }
        track.appendChild(img);
      });
    } else {
      hydrateSlides(track, index);
    }
    track.style.transform = 'translateX(' + (-index * 100) + '%)';
    if (track.classList.contains('is-dragging') && track.dataset.holeKey === key) {
      window.requestAnimationFrame(function () {
        track.classList.remove('is-dragging');
      });
    }
  }

  function urlsOf(card) {
    var active = card.querySelector('.hole-card__color.is-active');
    var raw = (active || card).dataset.holeImages || '[]';
    try {
      var urls = JSON.parse(raw);
      return Array.isArray(urls) ? urls : [];
    } catch (error) {
      return [];
    }
  }

  function sizesOf(card) {
    var active = card.querySelector('.hole-card__color.is-active');
    var raw = (active && active.dataset.holeSizes) || card.dataset.holeSizes || '[]';
    try {
      var sizes = JSON.parse(raw);
      return Array.isArray(sizes) ? sizes : [];
    } catch (error) {
      return [];
    }
  }

  function renderCard(card) {
    var urls = urlsOf(card);
    var index = Number(card.dataset.holeIndex || 0);
    if (index < 0) index = 0;
    if (index > urls.length - 1) index = Math.max(urls.length - 1, 0);
    card.dataset.holeIndex = String(index);
    var img = card.querySelector('.hole-card__photo');
    if (img && urls[index]) img.src = urls[index];
    paintStage(card, urls, index);
    var prev = card.querySelector('[data-hole-arrow="prev"]');
    var next = card.querySelector('[data-hole-arrow="next"]');
    if (prev) prev.disabled = index <= 0;
    if (next) next.disabled = index >= urls.length - 1;
    card.classList.toggle('hole-card--one-photo', urls.length < 2);
  }

  function ensureSheet() {
    if (sheet && document.contains(sheet)) return sheet;
    sheet = document.querySelector('[data-hole-collection-size-sheet]');
    if (!sheet) return null;
    grid = sheet.querySelector('[data-hole-size-grid]');
    if (sheet.parentElement !== document.body) document.body.appendChild(sheet);
    if (sheet.dataset.bound !== 'true') {
      sheet.dataset.bound = 'true';
      sheet.querySelectorAll('[data-hole-size-close]').forEach(function (button) {
        button.addEventListener('click', closeSheet);
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && sheet && !sheet.hidden) closeSheet();
      });
    }
    return sheet;
  }

  function fillSheet(sizes) {
    if (!grid) return;
    grid.replaceChildren();
    sizes.forEach(function (item) {
      var unavailable = !item.available;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'hole-size-sheet__size' + (unavailable ? ' is-unavailable' : '');
      button.textContent = item.size;
      if (unavailable) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.addEventListener('click', function () {
          addSize(item.id);
        });
      }
      grid.appendChild(button);
    });
  }

  function scrollbarGap() {
    return Math.max(0, window.innerWidth - root.clientWidth);
  }

  function lockSheetScroll() {
    root.style.setProperty('--hole-scrollbar-comp', scrollbarGap() + 'px');
    root.classList.add('hole-size-sheet-open');
  }

  function unlockSheetScroll() {
    root.classList.remove('hole-size-sheet-open');
    root.style.removeProperty('--hole-scrollbar-comp');
  }

  function openSheet(card) {
    if (!ensureSheet()) return;
    var sizes = sizesOf(card);
    if (!sizes.length) return;
    fillSheet(sizes);
    sheet.hidden = false;
    lockSheetScroll();
    var close = sheet.querySelector('.hole-size-sheet__close');
    if (close) close.focus();
  }

  function closeSheet() {
    if (!sheet) return;
    sheet.hidden = true;
    unlockSheetScroll();
  }

  function addSize(variantId) {
    closeSheet();
    if (!variantId) return;
    var addUrl = (window.routes && routes.cart_add_url) || '/cart/add.js';
    var formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', '1');
    var cartDrawer =
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cartDrawer.getSectionsToRender().map(function (section) {
          return section.section;
        })
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cartDrawer.setActiveElement === 'function') {
        cartDrawer.setActiveElement(document.activeElement);
      }
    }

    fetch(addUrl, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/javascript'
      },
      body: formData
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'hole-collection',
              productVariantId: variantId,
              errors: data.errors || data.description,
              message: data.message
            });
          }
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'hole-collection',
            productVariantId: variantId,
            cartData: data
          });
        }
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(data);
        } else if (typeof updateCartCounters === 'function') {
          updateCartCounters();
        }
      })
      .catch(function (error) {
        console.error('[hole-collection] cart add failed', error);
      });
  }

  var prefetchedImages = Object.create(null);

  function prefetchImage(url) {
    if (!url || prefetchedImages[url]) return;
    prefetchedImages[url] = true;
    try {
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.as = 'image';
      link.href = url;
      document.head.appendChild(link);
    } catch (error) {}
    var warmer = new Image();
    warmer.decoding = 'async';
    warmer.src = url;
  }

  function cardLcpUrl(card) {
    if (!card) return '';
    // PDP ilk kare = rengin ilk medyası (swipe index değil)
    var urls = urlsOf(card);
    if (urls[0]) return urls[0];
    var photo = card.querySelector('.hole-card__photo');
    return (photo && (photo.currentSrc || photo.src)) || '';
  }

  // Tıklamadan önce (pointerdown) PDP ilk fotosunu ısıt — gri kutu süresini kısaltır
  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    var link = event.target.closest('product-card.product-card--hole a.product-card__link');
    if (!link) return;
    var card = link.closest('product-card');
    prefetchImage(cardLcpUrl(card));
  }, true);

  document.addEventListener('click', function (event) {
    var quickAdd = event.target.closest('.product-card--hole .hole-card__quick-add');
    if (quickAdd) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      var quickCard = quickAdd.closest('product-card');
      if (quickCard) openSheet(quickCard);
      return;
    }

    var dragged = event.target.closest('a.product-card__link');
    if (dragged && dragged.dataset.holeDrag === '1') {
      event.preventDefault();
      event.stopPropagation();
      dragged.dataset.holeDrag = '';
      return;
    }

    var view = event.target.closest('[data-hole-views] [data-hole-cols]');
    if (view) {
      var cols = view.getAttribute('data-hole-cols');
      if (cols === '2') delete root.dataset.holeView;
      else root.dataset.holeView = cols;
      try {
        localStorage.setItem('hole-collection-view', cols);
      } catch (error) {}
      syncViews();
      return;
    }

    var color = event.target.closest('.hole-card__color');
    if (color) {
      var card = color.closest('product-card');
      if (!card) return;
      card.querySelectorAll('.hole-card__color').forEach(function (button) {
        var on = button === color;
        button.classList.toggle('is-active', on);
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      card.dataset.holeIndex = '0';
      if (color.dataset.holeSizes) card.dataset.holeSizes = color.dataset.holeSizes;
      if (color.dataset.holeImages) card.dataset.holeImages = color.dataset.holeImages;
      card.querySelectorAll('[data-product-link]').forEach(function (link) {
        link.href = color.dataset.holeUrl;
      });
      renderCard(card);
      return;
    }

    var arrow = event.target.closest('[data-hole-arrow]');
    if (!arrow || arrow.disabled) return;
    var arrowCard = arrow.closest('product-card');
    if (!arrowCard) return;
    var nextIndex = Number(arrowCard.dataset.holeIndex || 0);
    nextIndex += arrow.getAttribute('data-hole-arrow') === 'next' ? 1 : -1;
    arrowCard.dataset.holeIndex = String(nextIndex);
    renderCard(arrowCard);
  }, true);

  function applyStoredView() {
    var cols = null;
    try {
      cols = localStorage.getItem('hole-collection-view');
    } catch (error) {}
    if (cols === '1' || cols === '4') {
      root.dataset.holeView = cols;
      return;
    }
    if (cols === '2') {
      delete root.dataset.holeView;
      return;
    }
    // Tercih yoksa: mobil tekli, PC ikili
    if (isMobile()) root.dataset.holeView = '1';
    else delete root.dataset.holeView;
  }

  function boot() {
    applyStoredView();
    syncViews();
    ensureSheet();
    document.querySelectorAll('product-card.product-card--hole').forEach(renderCard);
  }

  function refreshCards() {
    ensureSheet();
    document.querySelectorAll('product-card.product-card--hole').forEach(renderCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('hole:cards:refresh', refreshCards);
  window.addEventListener('resize', function () {
    syncViews();
    refreshCards();
  });

  var gridRoot = document.querySelector('.template--collection');
  if (gridRoot && window.MutationObserver) {
    new MutationObserver(function () {
      syncViews();
    }).observe(gridRoot, { childList: true, subtree: true });
  }
})();
